import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';
registerModuleCatalog('user', (locale: Locale) => import(`./locales/${locale}.po`), { eager: true });
export const loadUserMessages = () => ensureModuleMessages('user');
